export default "https://cdn-static.gokick.com/assets/89c12df47656b56f32e50d5631dab02a560652ab/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";